<template>
  <div class="wrapper-login">
    <div class="container">
      <div class="row text-left">
        <div class="col-12 col-md-6 bg-left mt-4 m-md-auto">
          <h1>{{ $t('pages.login.login.title') }}</h1>
          <form>
            <b-alert
              variant="danger"
              :show="error != null"
            >
              <span
                v-if="error && error.accountUnverified"
              >
                {{ error.accountUnverified }}
                <span
                  class="resend-email"
                  @click="resendEmail"
                >
                  {{ $t('pages.login.login.email-resend') }}
                </span>
              </span>
              <span v-else>
                {{ error }}
              </span>
            </b-alert>
            <b-form-group
              id="fieldset-email"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="$t('inputs.email.title')"
              label-for="email"
              :invalid-feedback="$t('inputs.email.validation')"
              :state="emailState"
            >
              <b-form-input
                id="email"
                v-model="data.body.email"
                @keyup.enter="login"
              />
            </b-form-group>
            <b-form-group
              id="fieldset-password"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="$t('inputs.password.title')"
              label-for="password"
              :invalid-feedback="$t('inputs.password.validation')"
              :state="passwordState"
            >
              <b-form-input
                id="password"
                v-model="data.body.password"
                type="password"
                @keyup.enter="login"
              />
            </b-form-group>
            <div class="d-flex justify-content-between">
              <b-button
                variant="info"
                class="login-button"
                :disabled="!readyToSend"
                @click="login"
              >
                {{ $t('pages.login.login.button') }}
              </b-button>
              <router-link
                id="forgot-psw"
                :to="{ name: 'ForgotPassword' }"
              >
                {{ $t('pages.login.login.forgot-password') }}
              </router-link>
            </div>
          </form>
        </div>
        <div
          v-if="loginContext === 'candidate'"
          class="col-12 col-md-6 bg-grey mt-4 mt-md-0"
        >
          <h1 class="text-center mb-4">
            {{ $t('pages.login.register.title') }}
          </h1>
          <ul><li>{{ $t('pages.login.register.subtitle') }}</li></ul>
          <div class="row">
            <div class="col">
              <ul><li>{{ $t('pages.login.register.the-point') }}</li></ul>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register.first-point-title') }}</strong>
              <p>{{ $t('pages.login.register.first-point-subtitle') }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register.second-point-title') }}</strong>
              <p>{{ $t('pages.login.register.second-point-subtitle') }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register.third-point-title') }}</strong>
              <p>{{ $t('pages.login.register.third-point-subtitle') }}</p>
            </div>
          </div> -->
          <!-- <p>{{ $t('pages.login.register.first-offer') }}</p> -->
          <b-button
            variant="info"
            class="login-button --inverse mt-3"
            :disabled="!readyToSend"
            style="text-transform: uppercase"
            @click="register"
          >
            {{ $t('pages.login.register.button') }}
          </b-button>
        </div>
        <div
          v-else-if="loginContext === 'company'"
          class="col-12 col-md-6 bg-grey mt-4 mt-md-0"
        >
          <h1 class="text-center mb-4">
            {{ $t('pages.login.register-company.title') }}
          </h1>
          <ul><li>{{ $t('pages.login.register-company.subtitle') }}</li></ul>
          <div class="row">
            <div class="col">
              <ul><li>{{ $t('pages.login.register-company.work-success') }}</li></ul>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              {{ $t('pages.login.register-company.best-opportunities') }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register-company.first-point-title') }}</strong>
              <p>{{ $t('pages.login.register-company.first-point-subtitle') }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register-company.second-point-title') }}</strong>
              <p>{{ $t('pages.login.register-company.second-point-subtitle') }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <font-awesome-icon icon="sign-out-alt" />
            </div>
            <div class="col">
              <strong>{{ $t('pages.login.register-company.third-point-title') }}</strong>
              <p>{{ $t('pages.login.register-company.third-point-subtitle') }}</p>
            </div>
          </div> -->
          <!-- <p>{{ $t('pages.login.register-company.first-offer') }}</p> -->
          <b-button
            variant="info"
            class="login-button --inverse mt-3"
            :disabled="!readyToSend"
            style="text-transform: uppercase"
            @click="register"
          >
            {{ $t('pages.login.register-company.button') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        context: 'login context',
        data: {
            body: {
                email : "",
                password : ""
            },
            rememberMe: true,
            fetchUser: true
        },
        error: null,
        loginStart: true
      }
    },
    computed: {
      emailState() {
       /*eslint-disable */
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        /*eslint-enable */
        return (
          re.test(String(this.data.body.email).toLowerCase()) || this.loginStart
        );
      },
      passwordState() {
        return this.data.body.password.length >= 6 || this.loginStart;
      },
      readyToSend() {
        return this.emailState && this.passwordState;
      },
      appName() {
        return process.env.VUE_APP_NAME;
      },
      loginContext() {
        return window.localStorage.getItem('login-context') || 'candidate';
      },
    },
    methods: {
      login() {
        this.loginStart = false;

        if(this.emailState && this.passwordState) {
          this.$auth.login({
              data: this.data.body, // Axios
              rememberMe: this.data.rememberMe,
              fetchUser: this.data.fetchUser,
              redirect: false, //Will redirect on success, with isFirstLogin()
              success() {
                this.getPermissions();
                this.isFirstLogin();
                this.setLanguage(this.$auth.user().language)
              },
              error( error ) {
                this.error = error.response.data.error;
              }
          })
        }
      },
      setLanguage(lang) {
        this.$i18n.set(lang);
        this.axios.defaults.headers.common['Accept-Language'] = lang;
        window.localStorage.setItem('Language', lang);
      },
      register() {
        this.$router.push({ name: 'Register' })
      },
      async getPermissions() {
        if(this.$auth.check()) {
          await this.$store.dispatch('permissions/getPermissions')
            .then( () => {
              this.isError = false;
              this.isLoaded = true;
            })
            .catch( () => {
              this.isError = true;
            });
        } else {
          this.isLoaded = true;
        }
      },
      resendEmail() {
        this.axios.get('/auth/resendemail/' + this.data.body.email)
          .then(() => {
            this.error = null;
            this.$toastNotification('success', '', this.$t('pages.login.email-resent'));
          })
      },
      isFirstLogin() {
        this.axios.get('/cv/cvExists')
          .then( response => {
            if(!response.data && this.$hasRole(['candidate'])) {
              this.$router.push({ name: 'my-cv', params: { firstLogin: true }})
            } else {
              if(!this.$route.params.redirectTo) {
                this.$router.push({ name: 'dashboard'})
              } else {
                let rTo = this.$route.params.redirectTo;
                this.$router.push({ name: rTo.name, params: rTo.params})
              }
            }
          })
          .catch();
      },
    },
  }
</script>

<style scoped lang="scss">
  .wrapper-login {
    margin: -10px;
  }

  #form {
    margin-left: auto;
    margin-right: auto;
  }

  .login-button {
    font-size: 0.9rem;
    font-weight: 600;
    background: #009090;
    border: #009090;
    padding: 8px 15px;

    &:hover {
      background: #0d3750;
    }

    &.--inverse {
      background: transparent;
      border: 1px solid #009090;
      color: #009090;

      &:hover {
        background: #009090;
        color: #fff;
      }
    }
  }

  .bg-grey {
    background: #f2f2f2;
    padding: 50px 15px;
  }

  .bg-left {
    margin: auto;
  }

  .resend-email {
    text-decoration: underline;
    cursor: pointer;

    &:hover {
     font-weight: 600;
    }
  }

  #forgot-psw {
    font-size: 0.9rem;
  }
</style>
